'use client';
import React from 'react';

const ShimmerProjectCard: React.FC = () => {
  return (
    <div className="w-full rounded-xl shadow-md overflow-hidden bg-white">
      {/* Image skeleton */}
      <div className="h-60 w-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer"></div>

      {/* Contenu skeleton */}
      <div className="p-4 flex flex-col space-y-4">
        {/* Titre */}
        <div className="h-4 w-3/4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer rounded"></div>
        {/* Audience */}
        <div className="h-3 w-2/3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer rounded"></div>
        </div>
    </div>
  );
};

export default ShimmerProjectCard;
